import CardCategoryEdit from './CardCategoryEdit';

export default CardCategoryEdit;
